import type { CoreBundle, CoreBundlePayload } from '@flecto/types'

import { api } from '../../../services/api'

export type CreateBundleOptions = {
  enable?: boolean
}

/**
 * Create a new bundle.
 *
 * @endpoint POST /api/saas/me/bundles
 * @scope saas
 * @see https://flecto.dev/api-12969320
 */

export async function createBundle(
  bundle: Partial<CoreBundlePayload>,
  options?: CreateBundleOptions
): Promise<CoreBundle> {
  const { data } = await api.post('/api/saas/me/bundles', bundle, {
    params: options,
  })

  return data.bundle
}
